import { Small } from 'foundations-components/transitional/components/Small';
import { Big } from 'foundations-components/transitional/components/Big';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getPublicAchievementUrl } from '../../../utils/RoutingUtils';
import { CertificateBadge } from '../../achievementImages';
import { getMetadataLanguageFallback, useAchievementByTrackId, useAchievementTracks } from '../achievementQueries';
import { useAchievementImages } from '../../achievementImages/achievementImagesQueries';
import getLang from 'LearningCenterUI/utils/getLang';
import { useAchievementStatus } from '../achievementHooks';
import { CopyTextArea } from 'foundations-components/transitional/components/CopyTextArea';
import { CopyButton } from 'foundations-components/transitional/components/CopyButton';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const noop = () => {};
export const EmbedAward = ({
  onCopyAwardCode = noop,
  trackId,
  language = getLang()
}) => {
  const {
    images: {
      badgeURL
    },
    imagesLoading,
    imagesError
  } = useAchievementImages({
    trackId
  });
  const {
    achievement
  } = useAchievementByTrackId(trackId.toString());
  const {
    publicId
  } = achievement || {};
  const tracks = useAchievementTracks(publicId);
  const {
    name: trackName
  } = tracks ? getMetadataLanguageFallback(tracks[0].metadata, language) : {
    name: ''
  };
  const {
    urlSlug
  } = achievement && achievement.metadata && achievement.metadata ? getMetadataLanguageFallback(achievement.metadata, language) : {
    urlSlug: ''
  };
  const {
    isPrivate
  } = useAchievementStatus(trackId.toString());
  const isNotPubliclyVisible = imagesLoading || !!imagesError || isPrivate;
  const embedCode = publicId && `<!-- Begin: HubSpot Academy - ${trackName} Badge -->\n<div class='academy-badge'>\n<a href='${window.location.href.replace(/\/academy\/\d+\/.*$/, getPublicAchievementUrl(publicId, language, urlSlug))}' title='${trackName}'>\n<img src='${badgeURL}' />\n</a>\n</div>\n<!-- End: HubSpot Academy - ${trackName} Badge -->`;
  return /*#__PURE__*/_jsxs(TFlex, {
    align: "center",
    direction: "row",
    children: [/*#__PURE__*/_jsx(CertificateBadge, {
      trackId: trackId,
      width: 195
    }), /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(Big, {
          weight: "bold",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.embedAward.embedBadgeTitle"
          })
        }), /*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(Small, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "learningCenter.embedAward.embedBadgeToggleDescription"
            })
          })
        })]
      }), /*#__PURE__*/_jsx(CopyTextArea, {
        alignItems: "center",
        buttonRowRenderer: props => {
          return /*#__PURE__*/_jsx(CopyButton, Object.assign({}, props, {
            disabled: isNotPubliclyVisible,
            hint: isNotPubliclyVisible ? () => /*#__PURE__*/_jsx(FormattedMessage, {
              message: "learningCenter.embedAward.disabledCopyButtonHint"
            }) : undefined,
            marginInlineStart: "300",
            onClick: onCopyAwardCode,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "learningCenter.embedAward.copyEmbed"
            })
          }));
        },
        buttonUse: "tertiary",
        display: "flex",
        flexDirection: "row",
        flexWrap: "nowrap",
        textAreaProps: {
          disabled: isNotPubliclyVisible,
          minBlockSize: '40px',
          maxBlockSize: '40px',
          flexGrow: 1
        },
        use: "code",
        value: embedCode
      })]
    })]
  });
};